import React from 'react';

import SlideOne from '../imagens/slide5.jpg';
import SlideTwo from '../imagens/slide4.jpg';

class Slide extends React.Component {
    render(){
        return(
        <div>
            <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img className="d-block w-100 fullMobile2" src={SlideOne} alt="Primeiro Slide"></img>
                    </div>
                    <div className="carousel-item">
                        <img className="d-block w-100 fullMobile2" src={SlideTwo} alt="Segundo Slide"></img>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default Slide;